import React from "react";
import {AbsoluteFill, Sequence} from "remotion";
import {TVStatic} from "../components/dimus/TVStatic";
import {LightVolume} from "../components/dimus/LightVolume";
import {QuestionScene} from "../templates/dimus/QuizVideo/QuestionScene";
import {CTAScene} from "../templates/dimus/QuizVideo/CTAScene";
import {FRAMES_PER_QUESTION, FONT_STACK, BG_BLACK} from "../templates/dimus/QuizVideo/constants";
import type {QuizQuestion} from "../templates/dimus/QuizVideo/types";
import {OrganicLayer} from "../components/overlays/OrganicLayer";

/**
 * QUIZ #02 — "2 perguntas sobre growth"
 * Tema: métricas que donos de empresa ignoram
 * 60fps, glassmorphism, gamified
 */

const QUESTIONS: QuizQuestion[] = [
  {
    category: "RETENÇÃO",
    text: "Seu negócio cresce 20% ao ano mas perde 25% dos clientes. O que acontece em 3 anos?",
    options: [
      "Cresce devagar mas cresce",
      "Fica no mesmo lugar",
      "Encolhe — e você nem percebe",
      "Depende do ticket médio",
    ],
    correctIndex: 2,
  },
  {
    category: "CRESCIMENTO",
    text: "Você tem R$50k pra investir. CAC atual: R$200. LTV atual: R$180. O que fazer ANTES de investir?",
    options: [
      "Investir em tráfego pra escalar",
      "Corrigir o LTV — está perdendo dinheiro a cada cliente",
      "Diversificar canais de aquisição",
      "Contratar mais vendedores",
    ],
    correctIndex: 1,
  },
];

const CTA_FRAMES = 240;

export const QUIZ02_TOTAL =
  QUESTIONS.length * FRAMES_PER_QUESTION + CTA_FRAMES;

export const Quiz02: React.FC = () => {
  const ctaStart = QUESTIONS.length * FRAMES_PER_QUESTION;

  return (
    <OrganicLayer intensity="subtle" seed="quiz-02">
    <AbsoluteFill style={{backgroundColor: BG_BLACK, fontFamily: FONT_STACK}}>
      <TVStatic />
      <LightVolume />

      {QUESTIONS.map((q, i) => (
        <Sequence
          key={i}
          from={i * FRAMES_PER_QUESTION}
          durationInFrames={FRAMES_PER_QUESTION}
        >
          <QuestionScene question={q} index={i} />
        </Sequence>
      ))}

      <Sequence from={ctaStart} durationInFrames={CTA_FRAMES}>
        <CTAScene profile="@guilhermeribeiro.ai" objective="seguir" />
      </Sequence>
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
